module.exports = __webpack_public_path__ + "img/holidays.2fb13742.svg";